import React from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
interface SuccessProps {
  confirmYes: () => void;
  stayHere: () => void;
}
const UnsavedChanges: React.FC<SuccessProps> = ({ confirmYes, stayHere }) => {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-30">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden w-[500px]">
        <div className="p-6">
          <div className="ml-4 mt-3">
            <h3 className="text-base font-medium text-gray-900 text-center">
              Are you sure you want to leave this page? Unsaved changes will be
              lost
            </h3>
          </div>
          <div className="bg-white-50 px-4 py-2 mb-4 sm:px-6 sm:flex justify-center sm:flex-row-revers mt-5">
            <button
              type="button"
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
              onClick={stayHere}
            >
              Stay
            </button>
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white  sm:ml-3 sm:w-auto sm:text-sm mr-2"
              onClick={() => confirmYes()}
            >
              Yes, leave
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default UnsavedChanges;
